import cn from "classnames";
import type { ComponentProps } from "react";
import styles from "./TabPill.module.css";

function TabPill(props: ComponentProps<"button"> & { active?: boolean }) {
	const { className, active, ...rest } = props;
	return (
		<button
			className={cn(styles.pill, className, { [styles.active]: active })}
			type="button"
			{...rest}
		/>
	);
}

function TabPillList(props: ComponentProps<"div">) {
	const { className, ...rest } = props;

	return <div className={cn(styles.list, className)} {...rest} />;
}

const TabPillNamespace = Object.assign(TabPill, {
	List: TabPillList,
});

export { TabPillNamespace as TabPill };
